export default __webpack_public_path__ + "static/media/icon_settings_bo.f1170a2f.png";